import { useSelector } from 'react-redux';

import { ConfigProvider } from 'antd';

import Router from "./router/Router";
import store from './redux/store';
import * as actions from "./redux/Login/LoginTypes";
import { useEffect } from 'react';

export default function App() {
  const customise = useSelector(state => state.customise)
  var token = localStorage.getItem("token");
  if (token != undefined && token != "" && token != null) {
    store.dispatch({ type: actions.AUTHENTICATED, payload: { isAuthenticated: true } });
  }

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  useEffect(() => {
    clearCacheData();
  }, [])

  return (
    <ConfigProvider direction={customise.direction}>
      <Router />
    </ConfigProvider>
  );
}